import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';



@Component({
  selector: 'educational',
  templateUrl: "./mastereducationalformsemsgpi.component.html"
})
export class addMasterEducationalDetailsSemesterSGPI implements OnInit {
  FeedbackForm: FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid: string;
  @Input() admin_show: string;
  validations_flag = false;
  feedback_message;
  showExperience = false;

  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  semesterValidation = true;
  monthValidation = true;
  yearValidation = true;
  attemptValidation = true;
  instructionValidation = true;
  edu_data;
  course_data;
  user: any;

  constructor(protected api: ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<addMasterEducationalDetailsSemesterSGPI>) { }

  async ngOnInit() {
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: ['', Validators.required],
      collegeYearCtrl: ['', Validators.required],
      semesterCtrl: ['', Validators.required],
      monthCtrl: ['', Validators.required],
      yearCtrl: ['', Validators.required],
      overAllgpasgpiCtrl: ['', Validators.required],
      overmarksobtCtrl: ['', Validators.required],
      overmarksoutCtrl: ['', Validators.required],
      subjectFirstCtrl: ['', Validators.required],
      markFirstCtrl: ['', Validators.required],
      gradeFirstCtrl: ['', Validators.required],
      gradepointsFirstCtrl: ['', Validators.required],
      gradecreditsFirstCtrl: ['', Validators.required],
      subjectSecondCtrl: ['', Validators.required],
      markSecondCtrl: ['', Validators.required],
      gradeSecondCtrl: ['', Validators.required],
      gradepointsSecondCtrl: ['', Validators.required],
      gradecreditsSecondCtrl: ['', Validators.required],
      subjectThirdCtrl: ['', Validators.required],
      markThirdCtrl: ['', Validators.required],
      gradeThirdCtrl: ['', Validators.required],
      gradepointsThirdCtrl: ['', Validators.required],
      gradecreditsThirdCtrl: ['', Validators.required],
      subjectFourthCtrl: ['', Validators.required],
      markFourthCtrl: ['', Validators.required],
      gradeFourthCtrl: ['', Validators.required],
      gradepointsFourthCtrl: ['', Validators.required],
      gradecreditsFourthCtrl: ['', Validators.required],
      subjectFifthCtrl: [''],
      markFifthCtrl: [''],
      markFifthOutCtrl: [''],
      gradeFifthCtrl: [''],
      gradepointsFifthCtrl: [''],
      gradecreditsFifthCtrl: [''],
      subjectSixthCtrl: [''],
      markSixthCtrl: [''],
      markSixthOutCtrl: [''],
      gradeSixthCtrl: [''],
      gradepointsSixthCtrl: [''],
      gradecreditsSixthCtrl: [''],
      subjectSeventhCtrl: [''],
      markSeventhCtrl: [''],
      markSeventhOutCtrl: [''],
      gradeSeventhCtrl: [''],
      gradepointsSeventhCtrl: [''],
      gradecreditsSeventhCtrl: [''],
      subjectEighthCtrl: [''],
      markEighthCtrl: [''],
      markEighthOutCtrl: [''],
      gradeEighthCtrl: [''],
      gradepointsEighthCtrl: [''],
      gradecreditsEighthCtrl: [''],
      instructionCtrl: ['', Validators.required],
      // subjectNinthCtrl : [ ''],
      // markNinthCtrl : [ ''],
      // markNinthOutCtrl: [ ''],
      // gradeNinthCtrl :[''],
      // gradepointsNinthCtrl : [ ''],
      // gradecreditsNinthCtrl : [ ''],
      // subjectTenthCtrl : [ ''],
      // markTenthCtrl : [ ''],
      // markTenthOutCtrl: [ ''],
      // gradeTenthCtrl :[''],
      // gradepointsTenthCtrl : [ ''],
      // gradecreditsTenthCtrl : [ ''],
      specialInstrctionCtrl: [''],
      finalgradespecialInstrctionCtrl: [''],
      totalweeksCtrl: [''],
    })

    this.api.getCouses()
      .subscribe(
        (data: any) => {
          if (data['status'] == 200) {
            this.course_data = data['data'];

          } else {

          }
        });


    const now = new Date().getUTCFullYear();
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);


    if (this.user_id != null) {
      this.api.getEducation(this.edu_id, this.user_id)
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.edu_data = data['data'];

            } else {

            }
          });
    }
  }

  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.semesterValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;

    if (this.edu_form.valid == false) {
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overAllgpasgpiCtrl.markAsDirty();
      this.edu_form.controls.overmarksoutCtrl.markAsDirty();
      this.edu_form.controls.overmarksobtCtrl.markAsDirty();
      this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.gradeFirstCtrl.markAsDirty();
      this.edu_form.controls.gradepointsFirstCtrl.markAsDirty();
      this.edu_form.controls.gradecreditsFirstCtrl.markAsDirty();
      this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      this.edu_form.controls.markSecondCtrl.markAsDirty();
      this.edu_form.controls.gradeSecondCtrl.markAsDirty();
      this.edu_form.controls.gradepointsSecondCtrl.markAsDirty();
      this.edu_form.controls.gradecreditsSecondCtrl.markAsDirty();
      this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      this.edu_form.controls.markThirdCtrl.markAsDirty();
      this.edu_form.controls.gradeThirdCtrl.markAsDirty();
      this.edu_form.controls.gradepointsThirdCtrl.markAsDirty();
      this.edu_form.controls.gradecreditsThirdCtrl.markAsDirty();
      this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      this.edu_form.controls.markFourthCtrl.markAsDirty();
      this.edu_form.controls.gradeFourthCtrl.markAsDirty();
      this.edu_form.controls.gradepointsFourthCtrl.markAsDirty();
      this.edu_form.controls.gradecreditsFourthCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();

      if (this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value === '' || this.edu_form.controls.instructionCtrl.value === undefined) {
        this.instructionValidation = false;
      } else {
        this.instructionValidation = true;
      }

      if (this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value === '' || this.edu_form.controls.courseNameCtrl.value === undefined) {
        this.courseValidation = false;
      } else {
        this.courseValidation = true;
      }

      if (this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value === '' || this.edu_form.controls.collegeYearCtrl.value === undefined) {
        this.collegeYearValidation = false;
      } else {
        this.collegeYearValidation = true;
      }

      if (this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value === '' || this.edu_form.controls.semesterCtrl.value === undefined) {
        this.semesterValidation = false;
      } else {
        this.semesterValidation = true;
      }

      if (this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value === '' || this.edu_form.controls.monthCtrl.value === undefined) {
        this.monthValidation = false;
      } else {
        this.monthValidation = true;
      }

      if (this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value === '' || this.edu_form.controls.yearCtrl.value === undefined) {
        this.yearValidation = false;
      } else {
        this.yearValidation = true;
      }
    } else {
      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        semester: this.edu_form.controls.semesterCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        overall_gpa_sgpi: this.edu_form.controls.overAllgpasgpiCtrl.value,
        overall_marks_obt: this.edu_form.controls.overmarksobtCtrl.value,
        overall_marks_out: this.edu_form.controls.overmarksoutCtrl.value,
        subjectFirst: this.edu_form.controls.subjectFirstCtrl.value,
        marks_obt_First: this.edu_form.controls.markFirstCtrl.value,
        markFirst: this.edu_form.controls.gradeFirstCtrl.value,
        grade_points_First: this.edu_form.controls.gradepointsFirstCtrl.value,
        grade_credits_First: this.edu_form.controls.gradecreditsFirstCtrl.value,
        subjectSecond: this.edu_form.controls.subjectSecondCtrl.value,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        markSecond: this.edu_form.controls.gradeSecondCtrl.value,
        grade_points_Second: this.edu_form.controls.gradepointsSecondCtrl.value,
        grade_credits_Second: this.edu_form.controls.gradecreditsSecondCtrl.value,
        subjectThird: this.edu_form.controls.subjectThirdCtrl.value,
        marks_obt_Third: this.edu_form.controls.markThirdCtrl.value,
        markThird: this.edu_form.controls.gradeThirdCtrl.value,
        grade_points_Third: this.edu_form.controls.gradepointsThirdCtrl.value,
        grade_credits_Third: this.edu_form.controls.gradecreditsThirdCtrl.value,
        subjectFourth: this.edu_form.controls.subjectFourthCtrl.value,
        marks_obt_Fourth: this.edu_form.controls.markFourthCtrl.value,
        markFourth: this.edu_form.controls.gradeFourthCtrl.value,
        grade_points_Fourth: this.edu_form.controls.gradepointsFourthCtrl.value,
        grade_credits_Fourth: this.edu_form.controls.gradecreditsFourthCtrl.value,
        subjectFifth: this.edu_form.controls.subjectFifthCtrl.value,
        marks_obt_Fifth: this.edu_form.controls.markFifthCtrl.value,
        markFifth: this.edu_form.controls.gradeFifthCtrl.value,
        grade_points_Fifth: this.edu_form.controls.gradepointsFifthCtrl.value,
        grade_credits_Fifth: this.edu_form.controls.gradecreditsFifthCtrl.value,
        subjectSixth: this.edu_form.controls.subjectSixthCtrl.value,
        marks_obt_Six: this.edu_form.controls.markSixthCtrl.value,
        markSixth: this.edu_form.controls.gradeSixthCtrl.value,
        grade_points_Six: this.edu_form.controls.gradepointsSixthCtrl.value,
        grade_credits_Six: this.edu_form.controls.gradecreditsSixthCtrl.value,
        subjectSeventh: this.edu_form.controls.subjectSeventhCtrl.value,
        marks_obt_Seventh: this.edu_form.controls.markSeventhCtrl.value,
        markSeventh: this.edu_form.controls.gradeSeventhCtrl.value,
        grade_points_Seventh: this.edu_form.controls.gradepointsSeventhCtrl.value,
        grade_credits_Seventh: this.edu_form.controls.gradecreditsSeventhCtrl.value,
        subjectEighth: this.edu_form.controls.subjectEighthCtrl.value,
        marks_obt_Eighth: this.edu_form.controls.markEighthCtrl.value,
        markEighth: this.edu_form.controls.gradeEighthCtrl.value,
        grade_points_Eighth: this.edu_form.controls.gradepointsEighthCtrl.value,
        grade_credits_Eighth: this.edu_form.controls.gradecreditsEighthCtrl.value,
        // subjectNinth : this.edu_form.controls.subjectNinthCtrl.value,
        // marks_obt_Ninth : this.edu_form.controls.markNinthCtrl.value,
        // marks_out_Ninth : this.edu_form.controls.markNinthOutCtrl.value,
        // markNinth : this.edu_form.controls.gradeNinthCtrl.value,
        // grade_points_Ninth  : this.edu_form.controls.gradepointsNinthCtrl.value,
        // grade_credits_Ninth  : this.edu_form.controls.gradecreditsNinthCtrl.value,
        // subjectTenth : this.edu_form.controls.subjectTenthCtrl.value,
        // marks_obt_Tenth : this.edu_form.controls.markTenthCtrl.value,
        // marks_out_Tenth : this.edu_form.controls.markTenthOutCtrl.value,
        // markTenth : this.edu_form.controls.gradeTenthCtrl.value,
        // grade_points_Tenth  : this.edu_form.controls.gradepointsTenthCtrl.value,
        // grade_credits_Tenth  : this.edu_form.controls.gradecreditsTenthCtrl.value,
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        id: this.edu_id,
        special_instruction: this.edu_form.controls.specialInstrctionCtrl.value,
        final_grade_special_instruction: this.edu_form.controls.finalgradespecialInstrctionCtrl.value,
        total_weeks: this.edu_form.controls.totalweeksCtrl.value,
      }

      this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {
            this.ref.close(data);
            err => console.error(err)
          });
    }
  }

  dismiss() {
    this.ref.close();
  }

}
